export class DragAndDropUtils {

    public static separateValidInvalidFiles(allowedExtensions: string[], files: File[]) {
        const separatedFiles = {
            valid: [],
            invalid: []
        };

        for (const file of files) {
            const ext = file.name.split('.')[file.name.split('.').length - 1];

            if (allowedExtensions.lastIndexOf(ext.toLowerCase()) !== -1) {
                separatedFiles.valid.push(file);
            } else {
                separatedFiles.invalid.push(file);
            }
        }

        return separatedFiles;
    }

    private static S4() {
        // tslint:disable-next-line: no-bitwise
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }

    public static newGuid() {
        return (this.S4() + this.S4() + '-' +
                this.S4() + '-4' +
                this.S4().substr(0,3) + '-' +
                this.S4() + '-' + this.S4() +
                this.S4() + this.S4()).toLowerCase();
    }
}
